import { Injectable } from '@angular/core';
//import { SharedModule } from '../shared/shared.module';
//import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { ConfirmDialogOptions } from './confirm-dialog-options.interface';

//https://www.c-sharpcorner.com/article/confirm-dialog-in-angular-using-bootstrap-modal/

@Injectable()
export class ConfirmDialogService {
	private subject = new Subject<any>();
	private subjectResult = new Subject<any>();

	confirmThis(options: ConfirmDialogOptions, yesFn: () => void, noFn: () => void): any {
		//console.log('ConfirmDialogService.options:', options);
		this.setConfirmation(options, yesFn, noFn);
	}

	handleResult(finalResultValue: boolean, resultFunction: () => void) {
		return () => {
			this.subject.next();
			this.subjectResult.next(finalResultValue);
			resultFunction();
		};
	}

	setConfirmation(options: ConfirmDialogOptions, yesFn: () => void, noFn: () => void): any {
		//console.log('ConfirmDialogService.setConfirmation:', options);
		this.subject.next({
			type: 'confirm',
			options: options,
			yesFn: this.handleResult(true, yesFn),
			noFn: this.handleResult(false, noFn)
		});
	}

	getMessage(): Observable<any> {
		return this.subject.asObservable();
	}

	getResult(): Observable<any> {
		return this.subjectResult.asObservable();
	}
}